export default class FormaDePagamentoViewModel {
    constructor() {
        this.Id = undefined;
        this.FormaDePagamento = undefined;
        this.PorcentagemFinanceira = undefined;
        this.PrazoMedio = undefined;
        this.CodigoExterno = undefined;
        this.DataInclusaoFormatada = undefined;
        this.Excluido = undefined;
        this.OpcaoAtivo = undefined;
        this.AtivoTexto = undefined;
    }
}